import axios, { AxiosResponse } from 'axios';

// DELETE
// /ewosapi/v2/fieldregistration/fieldcollection/{fieldCollectionId}
export const deleteFieldCollection = async (fieldCollectionId: number): Promise<AxiosResponse> => {
  return await axios.delete<AxiosResponse>(`/ewosapi/v2/fieldregistration/fieldcollection/${fieldCollectionId}`);
};
